// React Component
// import React from "react";
import "./LoadingComponent.scss"; // Import the CSS

const LoadingSpinner = () => {
  return <div className="spinner"></div>;
};

export default LoadingSpinner;
